export const ALWAYS_TRUE_POLICY_ID = 'always-true';
